import { render, staticRenderFns } from "./formPemenuhan12.vue?vue&type=template&id=8cc158fa&"
import script from "./formPemenuhan12.vue?vue&type=script&lang=js&"
export * from "./formPemenuhan12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports